import noodleApiClient, { ApiDefinition } from '@noodleApi';
import buildPath from '@tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/ai/means-test']['POST'];
type Input = THIS_API['body'];
type Output = THIS_API['response'];

const calculateMeansTest = async ({ data, userWorkflowId, documentRequestUserId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/ai/means-test');
  const response = await noodleApiClient.post(path, { data, documentRequestUserId, userWorkflowId });
  return response.data;
};

export default calculateMeansTest;